import axios from 'axios';
import * as endpoint from '../../../endpoint';
import * as actionTypes from '../../../actionTypes';
import { consolelog, delCancelToken } from '../../../../lib/tools';
import { createCancelToken, handleErrorResponse } from '../../apis';
import { configureAxiosForJSON } from '../../axiosConfig';

/**
 * タグ取得apiを使用して複数階層のタグデータを取得する。
 * @param {string} apiToken - 認証用のAPIトークン
 * @param {Object} options - APIリクエストのオプション。`parentIds`（親タグのID配列）、
 *                           `isUsable`（使用可能なタグのみを取得するか）、`actionType`（ディスパッチするアクションのタイプ）、
 *                           `all`（全てのタグを取得するか）を含むオブジェクト。
 * @param {string} targetGroupId - 現在選択しているグループのID
 * @returns
 */
const getMultiLevelTags =
  (apiToken, { parentIds, isUsable, actionType, all = false }, targetGroupId) =>
  dispatch => {
    consolelog('[API CALL] getMultiLevelTags()');
    configureAxiosForJSON(apiToken);
    // eslint-disable-next-line no-eq-null
    if (targetGroupId === undefined) {
      return;
    }
    if (Array.isArray(parentIds) && parentIds.some(id => id <= 0)) {
      return;
    }

    const url = endpoint.API_GET_TAGS.replace('{groupId}', targetGroupId);
    const parentIdsStr = Array.isArray(parentIds)
      ? parentIds.join(' ')
      : parentIds;

    const { cancelToken, cancelTokenKey } =
      createCancelToken('getMultiLevelTags');
    const depth = (!all && !parentIds && 1) || null;
    const axiosParams = {
      params: {
        depth,
        parentIds: all ? null : parentIdsStr,
        isUsable: (isUsable && isUsable) || null,
        isDeleted: false,
      },
      cancelToken,
    };

    // eslint-disable-next-line consistent-return
    return axios
      .get(url, axiosParams)
      .then(res => {
        delCancelToken(cancelTokenKey);
        dispatch({
          type:
            (actionType && actionType) ||
            actionTypes.SUCCESS_API_GET_MULTI_LEVEL_TAGS,
          payload: res.data,
        });
      })
      .catch(thrown => {
        delCancelToken(cancelTokenKey);
        if (!axios.isCancel(thrown)) {
          handleErrorResponse(thrown, dispatch);
        }
      });
  };

export default getMultiLevelTags;
